import { neutralFillSubtleRest, neutralStrokeSubtleRest, strokeThickness } from '@adaptive-web/adaptive-ui/reference';
import { css } from '@microsoft/fast-element';
import { MatchMediaStyleSheetBehavior } from '@microsoft/fast-foundation';
import { darkModeQuery } from '../../style.js';

export default css`
	:host {
		display: block;
		width: 100%;
		background-color: var(--surface-color);
		border-top: ${strokeThickness} solid ${neutralStrokeSubtleRest};
		container: footer / inline-size;
		box-sizing: border-box;
	}

	[part=positioning-region] {
		display: grid;
		width: 100%;
		max-width: var(--max-content-width);
		min-height: 103px;
		margin: 0 auto;
		grid-template-columns: 1fr auto;
		padding: var(--padding-sm) var(--padding-md);
		align-items: center;
		height: fit-content;
		box-sizing: border-box;
	}

	adaptive-button {
		grid-column: 2;
		grid-row: 1;

		&::part(content) {
			display: flex;
		}
	}

	p {
		grid-column: 1;
		grid-row: 1;
		justify-self: flex-start;
		display: flex;
		align-items: center;
		gap: var(--padding-xs);
		flex-wrap: wrap;
		margin: 0;
		width: 100%;

		& svg {
			display: inline flex;
			width: unset;
			height: unset;
			max-height: 32spx;
		}
	}

	.logo-mark,
	.logo-mark-white {
		max-width: 32px;
	}

	.logo-mark {
		display: flex;
	}

	.logo-mark-white {
		display: none;
	}

	@media (max-width: 459px) {
		:host {
			min-height: max-content;
		}

		#to-top {
			display: none;
		}
	}

	@media (max-width: 375px) {
		p {
			justify-content: center;
			text-align: center;
		}
	}
`.withBehaviors(
	new MatchMediaStyleSheetBehavior(
		darkModeQuery,
		css`
			.logo-mark {
				display: none;
			}

			.logo-mark-white {
				display: flex;
			}
		`
	)
)